import React from 'react'
import { useDispatch } from 'react-redux'
import { callApi } from '../utils/callApi'
import { API_ROUTES } from '../utils/apiRoutes'
import { SnackBar } from '../components/ui/SnackBar'
import { GetAllTenders } from '../store/admin/tenders/actions'

interface IImageSyncEvent {
  tender: {
    id: number
    google_drive_sync_status: string
  }
}

export const useImageSync = () => {
  const [imageSyncLoading, setImageSyncLoading] = React.useState(false)
  const [itemImagesSyncLoading, setItemImagesSyncLoading] = React.useState(false)
  const { addSnackBar } = SnackBar()
  const dispatch = useDispatch()

  // eslint-disable-next-line consistent-return
  const startGoogleDriveImageSync = async (tenderId: number, withoutImages?: boolean) => {
    setImageSyncLoading(true)
    try {
      const resp = await callApi({
        method: 'post',
        path: API_ROUTES.googleDriveLoad,
        data: {
          only_new_files: withoutImages,
          // product_ids: [0],
          tender_id: tenderId,
        },
      })
      if (resp) {
        return resp
      }
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log(e)
      /// @ts-ignore
      const error = e?.data?.message || 'Google Drive image sync error'
      addSnackBar(error, false)
    } finally {
      setImageSyncLoading(false)
    }
  }

  // eslint-disable-next-line consistent-return
  const resyncItemImages = async (tenderId: number, itemId: number) => {
    setItemImagesSyncLoading(true)
    try {
      const resp = await callApi({
        method: 'post',
        path: API_ROUTES.googleDriveLoad,
        data: {
          product_ids: [itemId],
          tender_id: tenderId,
        },
      })
      if (resp) {
        return resp
      }
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log(e)
      /// @ts-ignore
      const error = e?.data?.message || 'Google Drive image sync error'
      addSnackBar(error, false)
    } finally {
      setItemImagesSyncLoading(false)
    }
  }

  const imageSyncSocketsListener = (event: IImageSyncEvent) => {
    if (event.tender.google_drive_sync_status === 'in_progress') {
      addSnackBar('Synchronization Started!', true)
    }

    const refreshData = async () => {
      dispatch(GetAllTenders.request())
    }

    if (event.tender.google_drive_sync_status === 'success') {
      addSnackBar('Successfully synced auction images. Update page for view images', true)
      refreshData()
    }

    if (event.tender.google_drive_sync_status === 'failed') {
      addSnackBar('Auction images synced with errors. Update page for view results', false)
      refreshData()
    }
  }

  return {
    startGoogleDriveImageSync,
    imageSyncLoading,
    imageSyncSocketsListener,
    resyncItemImages,
    itemImagesSyncLoading,
  }
}
